import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { getReaderReportById, getReaderReportByImei } from '../../services/readerReport.service';

import { ReaderReport } from '../../types/ReaderReport';
import { GetReaderReportRequest } from '../../requestModels/getReaderReportRequest';

interface ReaderReportState {
  readerReport?: ReaderReport;
  readerReports?: ReaderReport[];
  isReaderReportLoading: boolean;
}

const initialState: ReaderReportState = {
  readerReport: undefined,
  readerReports: undefined,
  isReaderReportLoading: false,
};

export const fetchReaderReportById = createAsyncThunk(
  'readers/getReaderReportById',
  async (param: GetReaderReportRequest) => await getReaderReportById(param)
);

export const fetchReaderReportByImei = createAsyncThunk('readers/getReaderReportByImei', async (param: any) => await getReaderReportByImei(param));

export const readerReportSlice = createSlice({
  name: 'readerReport',
  initialState,
  reducers: {
    updateReaderReportState: (state, action: PayloadAction<ReaderReport[] | undefined>) => {
      state.readerReports = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchReaderReportById.pending, (state) => {
        state.isReaderReportLoading = true;
      })
      .addCase(fetchReaderReportById.fulfilled, (state, action: PayloadAction<any>) => {
        if (action.payload.data?.results && action.payload.data?.results.length > 0) {
          state.readerReport = action.payload.data?.results[0] ?? null;
        }
        state.isReaderReportLoading = false;
      })
      .addCase(fetchReaderReportByImei.fulfilled, (state, action: PayloadAction<any>) => {
        if (action.payload.data) {
          state.readerReports = action.payload.data.results;
        }
      });
  },
});

export const { updateReaderReportState } = readerReportSlice.actions;
export default readerReportSlice.reducer;
